import isNotAnonAxiosError from '~/utility/isNotAnonAxiosError'
import { isAbortErrorFromEvent } from '~/utility/isAbortError'
import { buildAuthMachine, getAuthMachinePure } from './authMachine'
import { submitEmailLogin } from './services/email'
import { handleLoginSuccess } from './services/loginSuccess'
import { submitLogout } from './services/logout'
import { getMeInfo } from './services/me'
import { submitFacebookLogin, submitGoogleLogin } from './services/social'

export function authMachineFactory(fetchOptions?) {
  return buildAuthMachine(
    {
      getMeInfo: () => getMeInfo(fetchOptions),
      submitEmailLogin,
      submitFacebookLogin,
      submitGoogleLogin,
      submitLogout,
      handleLoginSuccess,
    },
    {
      logError: (_: any, event: any) => {
        if (!event || !event.data || !event.data.response) {
          return
        }

        // Filter out AbortErrors from navigation-based request cancellation
        if (isAbortErrorFromEvent(event)) {
          return
        }

        const response = event.data.response
        if (
          response &&
          (response.status === 403 || response.statusCode === 403)
        ) {
          return
        }
        if (isNotAnonAxiosError(event.data)) {
          event.data.name = `authMachine ${event.type} error - ${
            event.code ? event.code : ''
          }`
          console.error(event)
        }
      },
    },
  ).start(getAuthMachinePure().initialState)
}
